import { css } from '@emotion/react';
import {
  faCog, faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import {
  RoundButtonComponent, RoundButtonSize,
} from '~/_shared/baseComponents/buttons';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import { useTranslation } from '~/_shared/utils/hooks';

const toolbarButtonWrapperStyle = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  minHeight: 34,
  gap: 6,
});

export const ActiveDataLayerToolbarComponent = ({
  onEdit,
  onRemove,
}: Readonly<{
  onEdit: () => void;
  onRemove: () => void;
}>) => {
  const [t] = useTranslation();

  return (
    <div css={toolbarButtonWrapperStyle}>
      <div>
        <RoundButtonComponent
          icon={faCog}
          onClick={onEdit}
          buttonStyle={RoundButtonStyle.Primary}
          size={RoundButtonSize.Small}
          tooltipLabel={t('Edit')}
        />
      </div>
      <div>
        <RoundButtonComponent
          icon={faXmark}
          onClick={onRemove}
          buttonStyle={RoundButtonStyle.Danger}
          size={RoundButtonSize.Small}
          tooltipLabel={t('Delete')}
        />
      </div>
    </div>
  );
};
